<template>
    <div class="modal-card prd-modal-card">
        <header class="modal-card-head">
            <div>
                <p class="modal-card-title">Atualizar produção</p>
                <p class="is-size-7 has-text-grey">{{ model.descricao }}</p>
            </div>
            <button class="delete" @click="$emit('close')" />
        </header>
        <section class="modal-card-body">
            <b-field label="Situação">
                <b-select v-model="model.status" expanded>
                    <option :value="1">Aguardando produção</option>
                    <option :value="2">Em produção</option>
                    <option :value="3">Produção parcial</option>
                    <option :value="4">Problema na produção</option>
                    <option :value="5">Produção concluída</option>
                </b-select>
            </b-field>
            <b-field :label="`Quantidade produzida (solicitada: ${model.quantidadeSolicitada})`">
                <b-numberinput v-model="model.quantidadeProduzida" :min="0" :max="model.quantidadeSolicitada" :step="1" controls-position="compact" />
            </b-field>
            <b-field label="Observação"><b-input v-model.trim="model.observacoes" type="textarea" rows="3" /></b-field>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
            <b-button @click="$emit('close')">Cancelar</b-button>
            <b-button type="is-primary" icon-left="check" @click="$emit('salvar', model)">Salvar andamento</b-button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'PrdProducaoItemModal',
    props: { item: { type: Object, required: true } },
    data() {
        return { model: { ...JSON.parse(JSON.stringify(this.item)), quantidadeProduzida: Number(this.item.quantidadeSolicitada) } }
    },
}
</script>

<style scoped>
.prd-modal-card {
    width: min(560px, calc(100vw - 2rem));
}
</style>
